import { customToast } from "./customToast";

export const copyToClipboard = (title, value = "") => {
  navigator.clipboard.writeText(value);
  customToast({ msg: `${title} copied`, toastType: "SUCCESS" });
};
